import { render, staticRenderFns } from "./PurchaseOrderSend.vue?vue&type=template&id=2a1f58f4&"
import script from "./PurchaseOrderSend.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports